import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "../../constants/Routes";
import BaseController from "../sharedControllers/BaseController";
import { CreateUserDto } from "../../models/CreateUserDto";
import {
  IsUserAdmin,
  IsUserInternal,
  RefreshToken,
} from "akademika/akamont/services/AuthService";

/**
 * @namespace akademika.akamont.pages.userDetails
 */

export default class UserDetails extends BaseController {
  route = Routes.USER_DETAILS;
  parentRoute = Routes.USER_LIST;

  getUserDetailsUri = "api/User/GetUserDetails/{id}";
  editUserUri = "api/User/UpdateUser/{id}";
  id = "0";

  public async onRouteMatched() {
    this.setModel(new JSONModel({ value: IsUserAdmin() }), "isUserAdmin");
    this.setModel(new JSONModel({ value: IsUserInternal() }), "isUserInternal");

    this.setModel(
      new JSONModel({
        edit: false,
      }),
      "viewOptions"
    );

    this.id = this.routeParams.id;
    await this.getUserDetails();
    await this.fetchModel("api/User/GetUserOptions", "options");
  }

  public async getUserDetails() {
    const uri = this.getUserDetailsUri.replace("{id}", this.id);
    await this.fetchModel(uri);
  }

  public async onEditUser() {
    const viewOptionsModel = this.getModel("viewOptions") as JSONModel;
    let editValue = viewOptionsModel.getProperty("/edit");
    viewOptionsModel.setProperty("/edit", !editValue);

    if (editValue) {
      await this.getUserDetails();
    }
  }

  public async onSaveUser() {
    const requestData = this.getModelData<CreateUserDto>();
    const uri = this.editUserUri.replace("{id}", this.id);

    await this.saveDataAndShowMessage(uri, {
      body: requestData,
    })

    await RefreshToken();
    this.SetMenuModelName();

    const model = this.getModel("viewOptions");
    model.setProperty("/edit", false);
    await this.getUserDetails();
  }

  public onAdminDetails() {
    this.navTo(Routes.USER_DETAILS_ADMIN, { userId: this.id });
  }
}
